import { User } from '@/types/Auth';
import { GraphqlError } from '@/types/error';
import { parseUserRealTime } from '../parser';
import { useUserQuery } from './user.gql.impl';

const useUser = ({
  enabled,
  onSuccess,
  onError,
}: {
  enabled: boolean;
  onSuccess?: (data: User) => void;
  onError?: (error: GraphqlError) => void;
}) => {
  const { data } = useUserQuery(
    {},
    {
      select: parseUserRealTime,
      useErrorBoundary: false,
      retry: 0,
      enabled,
      onSuccess,
      onError,
    }
  );

  return {
    data,
  };
};

export default useUser;
